import React from 'react'
import { EditChatPromptProps } from 'chats/interfaces'
import ChatPrompt from './ChatPrompt'

export const EditChatPrompt = (props: EditChatPromptProps) => {
  return <ChatPrompt {...props} isNew={false} />
}

export default EditChatPrompt
